import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { BlogEntry } from '../../services/ubs-blog-model';
//import { BlogEntry } from '../../services';
//import { BlogEntry } from '@urbannex/blog/src/public-api';
//import { BlogEntry } from '@urbannex/blog/src/lib/services/ubs-blog-model';
//import { BlogEntry } from '../ubs-blog/';

@Component({
  selector: 'ubs-blog-article',
  templateUrl: './ubs-blog-article.component.html',
  styleUrls: ['./ubs-blog-article.component.scss']
})
export class UbsBlogArticleComponent implements OnInit {
  @Input() contentName:String;
  @Input() articleData:string;
  @Input() date:string;
  @Input() content:any;
  @Input() selectedBlogEntry:BlogEntry;
  
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["selectedBlogEntry"]){
      //console.log(this.selectedBlogEntry);
    }
  }

}
